module.exports = __webpack_public_path__ + "img/virtualManagement.80695b4d.svg";